import { useAuth0 } from "@auth0/auth0-react";
import { useMutation } from "@tanstack/react-query";
import { getHeaders } from "../../../helpers/helper";
import axiosInstance from "../../../shared/config/axiosInstance";
import { MutationKeys } from "../../../shared/react-query/mutationKeys";
import { PrepList } from "../../../shared/models/PrepList";

async function updatePrepListSettings(
  reqBody: PrepList,
  getAccessTokenSilently: any
) {
  const headers = await getHeaders(getAccessTokenSilently);

  const {data} = await axiosInstance.post("admin/SetPrepList", reqBody, {
    headers: { ...headers, "Content-Type": "application/json" },
  });

  return data;
}

export function useUpdatePrepListSettings() {
  const { getAccessTokenSilently } = useAuth0();

  return useMutation(
    (data: PrepList) =>
      updatePrepListSettings(data, getAccessTokenSilently),
    {
      mutationKey: [MutationKeys.PREP],
    }
  );
}
